import { inBiliApp, isNewJsBridge, isSupport } from '@bilibili/js-bridge'
import { isAndroid, isNode } from './utils'
import { BRIDGE_METHOD } from './enum'

export async function execRuntime(ua) {
  let version = 0
  let device = ''
  let bridgeIsV1 = false
  let bridgeIsV2 = false
  let bridgeIsV3 = false
  let bridgeIsV4 = false
  let bridgeIsV5 = false
  let bridgeIsV6 = false
  let bridgeIsV7 = false
  const result = {
    version: 0,
    uaDevice: '',
    uaVersion: 0,
    isMainApp: false
  }

  if (isNode || !inBiliApp) {
    return result
  }

  if (window.__bjax_exec_runtime && !ua) {
    return window.__bjax_exec_runtime
  }

  const _parseUA = () => {
    ;(ua || window.navigator.userAgent).split(' ').forEach((item) => {
      if (/^biliapp/i.test(item)) {
        version = +item.split('/')[1]
      } else if (/^mobi_app/i.test(item)) {
        device = item.split('/')[1]
      } else if (/^bilicomic/i.test(item)) {
        version = +item.split('/')[1]
      }
    })
  }

  /**
   * 混沌初开，梦开始的地方
   * @private
   */
  const _detectBridgeIsV1 = async () => {
    // UA 判断
    bridgeIsV1 =
      device === 'android_i' || // 哔哩哔哩 Android 国际版
      (device === 'android_comic' && version >= 21400000) // 哔哩哔哩漫画 Android

    // iOS 旧版本 v1 存在 bug
    const disableV1 =
      (device === 'iphone' && version < 8930) || // 哔哩哔哩 iOS 版
      (device === 'ipad' && version < 12350) || // 哔哩哔哩 iPad 版
      (device === 'iphone_b' && version < 8110) // 哔哩哔哩 iOS 概念版

    if (disableV1) {
      bridgeIsV1 = false
      return
    }
    /**
     * 再通过异步的方法判断一次
     */
    bridgeIsV1 = await isSupport(BRIDGE_METHOD.request)
  }

  /**
   * 解决客户端和前端多次 encode 的问题
   * @private
   */
  const _detectBridgeIsV2 = async () => {
    // UA 判断
    bridgeIsV2 =
      (device === 'bstar_i' && version >= 1000000) || // iOS 新国际版
      device === 'ios_bbs' ||
      device === 'UNKNOWN' || // 必剪 hot-fix
      (device === 'bstar_a' && version >= 1000013) || // Android 新国际版
      (device === 'iphone_i' && version >= 10000) || // iOS 旧国际版
      (device === 'android_i' && version >= 2050400) || // Android 旧国际版
      (device === 'android' && version > 5510000) || // 哔哩哔哩 Android
      (device === 'android_b' && version >= 5350000) || // 哔哩哔哩 Android 概念版
      (device === 'iphone' && version > 8960) || // 哔哩哔哩 iOS 版
      (device === 'ipad' && version > 12300) || // 哔哩哔哩 iPad 版
      (device === 'iphone_b' && version > 8990) || // 哔哩哔哩 iOS 概念版
      (device === 'android_comic' && version >= 21610000) || // 哔哩哔哩漫画 Android
      (device === 'android_bbs' && version >= 1000200) // BBS
    /**
     * 再通过异步的方法判断一次
     */
    if (bridgeIsV2) {
      bridgeIsV2 = await isSupport(BRIDGE_METHOD.request)
    }
  }

  /**
   * 再次解决客户端和前端多次 encode 的问题，但引入了更多的问题
   * @private
   */
  const _detectBridgeIsV3 = async () => {
    /**
     * Android 有 bug
     */
    if (isAndroid) {
      return
    }
    /**
     * v3 的实现有 bug，所以我们就不走 v3 了
     * 漫画 APP iOS/iPad 只支持了 net.requestWithSign，所以漫画走 v3
     */
    if (device !== 'iphone_comic' && device !== 'ipad_comic') {
      return
    }

    bridgeIsV3 = true
    bridgeIsV3 = await isSupport(BRIDGE_METHOD.requestWithSign)
  }

  /**
   * 解决 csrf 校验的问题，本应该在 v1 就解决的问题
   * @private
   */
  const _detectBridgeIsV4 = async () => {
    // UA 判断
    bridgeIsV4 =
      (device === 'iphone' && version > 10000) || // 哔哩哔哩 iOS 版
      (device === 'iphone_i' && version >= 10000) || // 哔哩哔哩 iOS 国际版
      (device === 'iphone_b' && version > 9360) || // 哔哩哔哩 iOS 概念版
      (device === 'ipad' && version > 12390) || // 哔哩哔哩 iPad 版
      (device === 'android' && version >= 6010000) || // 哔哩哔哩 Android
      (device === 'android_b' && version >= 5410000) || // 哔哩哔哩 Android 概念版
      (device === 'android_bbs' && version >= 1000200) // Android BBS
    if (bridgeIsV4) {
      bridgeIsV4 = await isSupport(BRIDGE_METHOD.requestWithSign)
    }
  }

  /**
   * V5版本有 bug
   * @private
   */
  const _detectBridgeIsV5 = async () => {
    bridgeIsV5 = device === 'android' && version >= 6060100 && version <= 6060210
    if (bridgeIsV5) {
      bridgeIsV5 = await isSupport(BRIDGE_METHOD.requestWithSign)
    }
  }

  /**
   * V6 新的篇章，新的征程，新的 bug
   * @private
   */
  const _detectBridgeIsV6 = async () => {
    // UA 判断
    bridgeIsV6 =
      (device === 'android' && version >= 6070600) || // 哔哩哔哩 Android 版
      (device === 'android_b' && version >= 6070520) || // 哔哩哔哩 Android 概念版
      (device === 'bstar_a' && version >= 1041000) || // 新 Android 国际版
      (device === 'bstar_i' && version >= 1041000) || // 新 iOS 国际版
      (device === 'iphone' && version >= 10180) || // 哔哩哔哩 iOS 版
      (device === 'iphone_b' && version >= 10182) || // 哔哩哔哩 iOS 概念版
      (device === 'ipad' && version >= 12391) // 哔哩哔哩 iPad 版

    if (bridgeIsV6) {
      bridgeIsV6 = await isSupport(BRIDGE_METHOD.requestV2)
    }
  }

  /**
   * 这个版本只是增加了去除 iOS 老 bug 的兼容，小意思小意思
   * @private
   */
  const _detectBridgeIsV7 = async () => {
    // UA 判断
    bridgeIsV7 =
      device === 'pangu_android' || // 盘古 android
      device === 'pangu_ios' || // 盘古 iOS
      device === 'android_tv_yst' || // Android TV
      device === 'android_hd' || // Android HD 版
      device === 'ios_hikari' || // 光呆ios
      device === 'android_hikari' || // 光呆安卓
      device === 'android_tv_bst' || // Android 百世通
      (device === 'iphone' && version >= 10030) || // 哔哩哔哩 iOS 版
      (device === 'iphone_b' && version >= 10030) || // 哔哩哔哩 iOS 概念版
      (device === 'ipad' && version >= 12420) || // 哔哩哔哩 iPad 版
      (device === 'biliLink' && version >= 5060000) || // iOS 直播姬 APP
      (device === 'biliLink_Android' && version >= 5070020) // Android 直播姬 APP

    if (bridgeIsV7) {
      bridgeIsV7 = await isSupport(BRIDGE_METHOD.requestV2)
    }
  }

  _parseUA()
  // 这里需要按顺序执行，不能并行
  await _detectBridgeIsV7()
  await _detectBridgeIsV6()
  await _detectBridgeIsV5()
  await _detectBridgeIsV4()
  await _detectBridgeIsV3()
  await _detectBridgeIsV2()
  await _detectBridgeIsV1()

  if (bridgeIsV1) {
    result.version = 1
  }

  if (bridgeIsV2) {
    result.version = 2
  }

  if (bridgeIsV3) {
    result.version = 3
  }

  if (bridgeIsV4) {
    result.version = 4
  }

  if (bridgeIsV5) {
    result.version = 5
  }

  if (bridgeIsV6) {
    result.version = 6
  }

  if (bridgeIsV7) {
    result.version = 7
  }
  // eslint-disable-next-line
  result.isMainApp = ['iphone', 'iphone_b', 'ipad', 'android', 'android_b'].indexOf(device) !== -1
  result.uaDevice = device
  result.uaVersion = version

  window.__bjax_exec_runtime = result

  return result
}

export async function execSupport(reset) {
  const result = {
    v1: false,
    v2: false,
    version: 0
  }

  if (isNode || !inBiliApp || !isNewJsBridge()) {
    return result
  }

  if (window.__bjax_exec_support && !reset) {
    return window.__bjax_exec_support
  }

  /**
   * Android 的 v1 有 bug
   */
  if (!isAndroid) {
    result.v1 = await isSupport(BRIDGE_METHOD.uploadImage)
  }

  result.v2 = await isSupport(BRIDGE_METHOD.uploadImageV2)

  window.__bjax_exec_support = result

  return result
}
